<template>
  <div class="home">
    <div v-if="user.dottorfarma">
      <video
        loop
        autoplay
        muted
        heigth="87"
        preload="auto"
        poster="/img/preloaderconnessa.png"
        class="banner__video"
      >
        <source src="/video/teleconsulto_connessa.mp4" type="video/mp4" />
      </video>
    </div>
    <div v-if="showError">
      <p>{{ this.error }}</p>
      <div v-if="this.errors.anagrafica">
        <b-button variant="primary" @click="gotToAnagrafica">Compila anagrafica</b-button>
      </div>
      <div v-if="this.errors.email">
        <b-button variant="primary" @click="gotToResend">Verifica</b-button>
      </div>
    </div>
    <div v-else class="mt-4">
      <div v-if="!loading">
        <funzioni-paziente
          v-if="this.user.role === 'paziente'"
          :nome="this.user.anagrafica.fullname"
        />
        <funzioni-dottorfarma
          v-if="this.user.tipologia === 'professionista' && this.user.dottorfarma"
          :nome="this.user.anagrafica.fullname"
          :notimeflag="showOrariBtn"
        />
        <funzioni-professionista
          v-else-if="this.user.tipologia === 'professionista'"
          :nome="this.user.anagrafica.fullname"
          :notimeflag="showOrariBtn"
          :farmacistaflag="user.role === 'farmacista'"
        />
        <funzioni-admin v-if="this.user.role === 'admin'" :nome="this.user.anagrafica.fullname" />
        <prossimi-consulti
          v-if="this.user.tipologia === 'professionista' && this.user.servizi_attivi.length >0"
          :isPaziente="false"
        />
        <prossimi-consulti v-else-if="this.user.tipologia === 'paziente'" :isPaziente="true" />
      </div>
    </div>
  </div>
</template>

<script>
import FunzioniPaziente from "@/components/homepage/FunzioniPaziente";
import FunzioniProfessionista from "@/components/homepage/FunzioniProfessionista";
import FunzioniDottorfarma from "@/components/homepage/FunzioniDottorfarma";
import FunzioniAdmin from "@/components/homepage/FunzioniAdmin";
import ProssimiConsulti from "@/components/homepage/ProssimiConsulti";
export default {
  name: "Home",
  components: {
    FunzioniPaziente,
    FunzioniProfessionista,
    FunzioniDottorfarma,
    FunzioniAdmin,
    ProssimiConsulti
  },
  data() {
    return {
      user: "",
      loading: true,
      showError: false,
      error: false,
      errors: {
        anagrafica: false,
        email: false
      },
      showOrariBtn: false
      // abbonamentoScaduto: false
    };
  },
  watch: {},
  methods: {
    fetchData() {
      var url = process.env.VUE_APP_VERSION + "users/user";
      this.$axios
        .get(url)
        .then(res => {
          this.user = res.data.data;
          // console.log(this.user);
          if (!this.user.anagrafica) {
            this.showError = true;
            this.errors.anagrafica = true;
            this.error = "Non hai ancora completato la tua scheda anagrafica";
            return;
          }
          if (this.user.tipologia === "professionista") {
            return this.getOwn();
          }
          this.loading = false;
        })
        .catch(err => {
          // console.log(err.response.status);
          if (err.response.status === 403) {
            this.showError = true;
            this.errors.email = true;
            this.error =
              "Non hai ancora verificato il tuo indirizzo email, controlla la tua casella di posta elettronica";
          }
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    getOwn() {
      console.log("get own");
      var url = process.env.VUE_APP_VERSION + "ricevimento/own";
      this.$axios
        .get(url)
        .then(res => {
          // console.log(res.data.data);
          if (res.data.data.length < 1) {
            this.showOrariBtn = true;
          }
          if (
            this.user.tipologia === "professionista" &&
            !this.user.abbonamento
          ) {
            this.showError = true;
            this.error = "Nessun abbonamento attivo";
          }
          // }
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    gotToAnagrafica() {
      this.$router.push({ name: "RegisterAnagrafica" });
    },
    gotToResend() {
      this.$router.push({ name: "VerifyEmail" });
    }
    // resend() {
    //   this.$axios
    //     .get("/email/resend")
    //     .then(() => {
    //       this.hasResend = true;
    //     })
    //     .catch(err => {
    //       if (err.response.data.data.verificata) {
    //         this.alreadyVerified = true;
    //       }
    //     });
    // }
  },
  created() {
    this.fetchData();
  }
};
</script>
